/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  MailAuthorizeRequest,
  MailAuthorizeResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The consent URL, built here rather than in the browser.
 *
 * Only the server can mint a state it will recognise on the way back, keep the
 * PKCE verifier somewhere the browser cannot read, and set `access_type` and
 * `prompt` on Google, which its JS code client does not expose at all. The
 * calendar learned each of those the hard way; `v1/oauth_state` carries the
 * account.
 * @summary Begin Mailbox Authorization
 */
export const beginMailboxAuthorization = (
    provider: string,
    mailAuthorizeRequest: MailAuthorizeRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<MailAuthorizeResponse>(
      {url: `/mailbox/${provider}/authorize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailAuthorizeRequest, signal
    },
      options);
    }




export const getBeginMailboxAuthorizationMutationKey = () => ['beginMailboxAuthorization'] as const;

export const getBeginMailboxAuthorizationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginMailboxAuthorization>>, TError,BeginMailboxAuthorizationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof beginMailboxAuthorization>>, TError,BeginMailboxAuthorizationMutationVariables, TContext> => {

const mutationKey = getBeginMailboxAuthorizationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof beginMailboxAuthorization>>, BeginMailboxAuthorizationMutationVariables> = (props) => {
          const {provider,data} = props ?? {};

          return  beginMailboxAuthorization(provider,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BeginMailboxAuthorizationMutationResult = NonNullable<Awaited<ReturnType<typeof beginMailboxAuthorization>>>
    export type BeginMailboxAuthorizationMutationBody = MailAuthorizeRequest
    export type BeginMailboxAuthorizationMutationError = HTTPValidationError
    export type BeginMailboxAuthorizationMutationVariables = {provider: string;data: MailAuthorizeRequest}

    /**
 * @summary Begin Mailbox Authorization
 */
export const useBeginMailboxAuthorization = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beginMailboxAuthorization>>, TError,BeginMailboxAuthorizationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof beginMailboxAuthorization>>,
        TError,
        BeginMailboxAuthorizationMutationVariables,
        TContext
      > => {
      return useMutation(getBeginMailboxAuthorizationMutationOptions(options));
    }
